export default __webpack_public_path__ + "static/media/avatar_xiao_mei1.507d86f3.mp3";